<template>
    <div>
        <div class="row fipe">
            <woot-button @click="addFipe">Adicionar FIPE</woot-button>
            <table v-if="data.length" class="woot-table">
      <thead>
        <tr>
            <th>{{ $t('INTEGRATION_APPS.FIPE.TABLE.PLAN') }}</th>
          <th>{{ $t('INTEGRATION_APPS.FIPE.TABLE.PRICE') }}</th>
          <th>{{ $t('INTEGRATION_APPS.FIPE.TABLE.FIPE_MIN') }}</th>
          <th>{{ $t('INTEGRATION_APPS.FIPE.TABLE.FIPE_MAX') }}</th>
          <th>{{ $t('INTEGRATION_APPS.FIPE.TABLE.ACTIONS') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in data" :key="index">
            <td>{{ item.plan_name }}</td>
          <td>{{ item.preco }}</td>
          <td>{{ item.fipeMinimo }}</td>
          <td>{{ item.fipeMaximo }}</td>
          <td class="button-wrapper">
                <woot-button
                  v-tooltip.top="$t('CANNED_MGMT.EDIT.BUTTON_TEXT')"
                  variant="smooth"
                  size="tiny"
                  color-scheme="secondary"
                  icon="edit"
                @click="openEditPopup(item)"
                />
                <woot-button
                  v-tooltip.top="$t('CANNED_MGMT.DELETE.BUTTON_TEXT')"
                  variant="smooth"
                  color-scheme="alert"
                  size="tiny"
                  icon="dismiss-circle"
                  class-names="grey-btn"
                @click="openDeletePopup(item)"
                />
            </td>
        </tr>
      </tbody>
    </table>

    </div>

        <modal-add-fipe
            v-if="showAddFipe"
            :onClose="closeModalAddFipe"
            :integration="integration"
        />

        <modal-edit-fipe
            v-if="showEditPopup"
            :onClose="hideEditPopup"
            :integration="integration"
            :fipeData="selectedResponse"
        />


        <woot-delete-modal
            :show.sync="showDeleteConfirmationPopup"
            :on-close="closeDeletePopup"
            :on-confirm="confirmDeletion"
            :title="$t('CANNED_MGMT.DELETE.CONFIRM.TITLE')"
            :message="$t('CANNED_MGMT.DELETE.CONFIRM.MESSAGE')"
            message-value="?"
            :confirm-text="this.$t('CANNED_MGMT.DELETE.CONFIRM.YES')"
            :reject-text="this.$t('CANNED_MGMT.DELETE.CONFIRM.NO')"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ModalAddFipe from './ModalAddFipe.vue';
import ModalEditFipe from './ModalEditFipe.vue';
import alertMixin from 'shared/mixins/alertMixin';
import Modal from '../../../../../components/Modal.vue';

export default {
    name: 'Fipe',
    mixins: [alertMixin],
    components: { ModalAddFipe, ModalEditFipe, Modal },
    props: {
        
        integration: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            showDeleteConfirmationPopup: false,
            selectedResponse: {},
            client_id: '',
            showAddFipe: false,
            fetchingList: false,
            showEditPopup: false,
        };
    },

    computed: {
        ...mapGetters({
            data: 'getFipes',
        })
    },

    methods: {
        addFipe() {
            this.showAddFipe = true;
        },
        closeModalAddFipe() {
            this.showAddFipe = false;
        },
        openDeletePopup(response) {
            this.showDeleteConfirmationPopup = true;
            this.selectedResponse = response;
        },
        closeDeletePopup() {
            this.showDeleteConfirmationPopup = false;
        },
        confirmDeletion() {
            this.$store.dispatch('deleteFipe', this.selectedResponse.id)
            .then(() => {
                this.showAlert(this.$t('INTEGRATION_APPS.FIPE.DELETE.API.SUCCESS_MESSAGE'));
            })
            .catch(() => {
                this.showAlert(this.$t('INTEGRATION_APPS.FIPE.DELETE.API.ERROR_MESSAGE'));
            });
            this.closeDeletePopup();
        },

        openEditPopup(response) {
            this.showEditPopup = true;
            this.selectedResponse = response;
        },
        hideEditPopup() {
            this.showEditPopup = false;
        }
    },
}
</script>
<style>
.fipe {
  margin-top: 1rem;
}
</style>